import React, { useState, useEffect, useRef } from "react";
import { Table, Select, Spin, message } from "antd";
import axios from "axios";
import { IoInformationCircleOutline } from "react-icons/io5";

const TradeHistoryFuture = (props) => {
  const { type, apiKey,apiSecret,selectedapi } = props?.data;
  const [historyData, setHistoryData] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Api, setApi] = useState("option[0]?.label");
  const [CheckBal, setCheckBal] = useState([]);
  const symbols = ["ETHUSDT", "MANAUSDT", "XRPUSDT", "SOLUSDT", "BNBUSDT","DOGEUSDT"];

  const createdAt = selectedapi?.datetime;

  const startTime = new Date(createdAt).getTime();

  const checkSpotBalance = async () => {
    setCheckBal(null);
    setLoading(true);
    const token = localStorage.getItem("jwt");
   

    try {
   
      const allOrders = [];

      for (const symbol of symbols) {
        const secondApiData = {
          request_type: "private",
          method: "GET",
          key: apiKey,
          secret: apiSecret,
          endpoint: "/fapi/v1/allOrders",
          params: {
            symbol: symbol,
            // startTime: startTime,
          },
        };

        const secondRes = await axios({
          method: "POST",
          headers: { "Content-Type": "application/json" },
          url: process.env.REACT_APP_API_ALLCOINSF + "/make_request",
          data: secondApiData,
        });

        allOrders.push(...secondRes.data.Success);
      }

      const formattedData = allOrders.map((order) => ({
        time: new Date(order.time),
        orderId: order.orderId,
        symbol: order.symbol,
        type: order.type,
        side: order.side,
        avgPrice: order.avgPrice,
        price: order.price,
        origQty: order.origQty,
        positionSide: order.positionSide,
        status: order.status,
        executedQty: order.executedQty,
      }));

      setHistoryData(formattedData);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    if (selectedapi) {
      checkSpotBalance();
    }
  }, [selectedapi]);


  const symbol = [
    "ADA",
    "BNB",
    "BTC",
    "DOGE",
    "ETH",
    "GALA",
    "MANA",
    "OCEAN",
    "SOL",
    "XRP",
  ];
  const [selectedSymbols, setSelectedSymbols] = useState(symbol);

const sortedHistoryData = historyData?.length > 0
? [...historyData].sort((a, b) => new Date(b.time) - new Date(a.time)) 
: [];

const dataSource = sortedHistoryData?.length > 0
? sortedHistoryData.map((data, index) => ({
    key: index + 1, 
    sequence: <p className="text-center">{index + 1}</p>,
    orderId: <p className="text-center">{data?.orderId}</p>,
    executedQty: <p className="text-center">{data?.executedQty}</p>,
    Orig_Type: <p className="text-center">{data?.type}</p>,
    side: (
      <p
        className={`text-center ${
          data?.side === "BUY" ? "text-green-500" : "text-red-500"
        }`}
      >
        {data?.side}
      </p>
    ),
    status: (
      <p
        className={`text-center ${
          data?.status === "FILLED" ? "text-green-500" : "text-red-500"
        }`}
      >
        {data?.status}
      </p>
    ),
    symbol: <p className="text-center">{data?.symbol}</p>,
    time: (
      <p className="text-center">
        {new Date(data?.time).toLocaleDateString("en-GB") +  
          " " +
          new Date(data?.time).toLocaleTimeString()}    
      </p>
    ),
    type: <p className="text-center">{data?.type}</p>,
    avgPrice: <p className="text-center">{data?.avgPrice}</p>,
    origQty: <p className="text-center">{data?.origQty}</p>,
    positionSide: <p className="text-center">{data?.positionSide}</p>,
  }))
: [
    {
      sequence: <p className="text-center">*****</p>,
      orderId: <p className="text-center">*****</p>,
      executedQty: <p className="text-center">*****</p>,
      Orig_Type: <p className="text-center">*****</p>,
      side: <p className="text-center">*****</p>,
      status: <p className="text-center">*****</p>,
      symbol: <p className="text-center">*****</p>,
      time: <p className="text-center">*****</p>,
      type: <p className="text-center">*****</p>,
      avgPrice: <p className="text-center">*****</p>,
      origQty: <p className="text-center">*****</p>,
      positionSide: <p className="text-center">*****</p>,
    },
  ];


  // const dataSource =
  //   historyData?.length > 0
  //     ? historyData.map((data) => ({
        
  //         orderId: <p className=" text-center">{data?.orderId}</p>,
  //         executedQty: <p className=" text-center">{data?.executedQty}</p>,
  //         Orig_Type: <p className=" text-center">{data?.type}</p>,
  //         side: (
  //           <p
  //             className={`text-center ${
  //               data?.side === "BUY" ? "text-green-500" : "text-red-500"
  //             }`}
  //           >
  //             {data?.side}
  //           </p>
  //         ),
  //         status: (
  //           <p
  //             className={`text-center ${
  //               data?.status === "FILLED" ? "text-green-500" : "text-red-500"
  //             }`}
  //           >
  //             {data?.status}
  //           </p>
  //         ),
  //         symbol: <p className="text-center">{data?.symbol}</p>,
  //         time: (
  //           <p className="text-center">
  //             {new Date(data?.time).toLocaleDateString("en-GB") +
  //               " " +
  //               new Date(data?.time).toLocaleTimeString()}
  //           </p>
  //         ),
  //         type: <p className="text-center">{data?.type}</p>,
  //         avgPrice: <p className="text-center">{data?.avgPrice}</p>,
  //         origQty: <p className="text-center">{data?.origQty}</p>,
  //         positionSide: <p className="text-center">{data?.positionSide}</p>,
  //       }))
  //     : [
  //         {
  //           orderId: <p className="text-center">*****</p>,
  //           executedQty: <p className="text-center">*****</p>,
  //           Orig_Type: <p className="text-center">*****</p>,
  //           side: <p className="text-center">*****</p>,
  //           status: <p className="text-center">*****</p>,
  //           symbol: <p className="text-center">*****</p>,
  //           time: <p className="text-center">*****</p>,
  //           type: <p className="text-center">*****</p>,
  //           avgPrice: <p className="text-center">*****</p>,
  //           origQty: <p className="text-center">*****</p>,
  //           positionSide: <p className="text-center">*****</p>,
  //         },
  //       ];

  const columns = [
    {
      title: <p className="p-1 text-center ">Order ID</p>,
      dataIndex: "orderId",
      key: "orderid",
      width: 200,
    },
    {
      title: <p className="p-1 text-center ">DateTime</p>,
      dataIndex: "time",
      key: "Time",
      width: 200,
    },
    {
      title: <p className="p-1 text-center ">Symbol</p>,
      dataIndex: "symbol",
      key: "Symbol",
    },

    {
      title: <p className="p-1 text-center ">Type</p>,
      dataIndex: "type",
      key: "Orig_Type",
    },
    {
      title: <p className="p-1 text-center ">Side</p>,
      dataIndex: "side",
      key: "Side",
    },
    {
      title: <p className="p-1 text-center ">Average</p>,
      dataIndex: "avgPrice",
      key: "Avg_Price",
    },
    // {
    //   title: <p className='p-1 text-center '>Price</p>,
    //   dataIndex: 'Price',
    //   key: 'Price',
    // },
    {
      title: (
        <p className="p-1 text-center ">Executed Qty</p>
      ),
      dataIndex: "executedQty",
      key: "Executed_Qty",
    },
    {
      title: <p className="p-1 text-center ">Orig Qty</p>,
      dataIndex: "origQty",
      key: "Orig_Qty",
    },
    {
      title: (
        <p className="p-1 text-center ">Position Side</p>
      ),
      dataIndex: "positionSide",
      key: "Position_Side",
    },
    {
      title: <p className="p-1 text-center ">Status</p>,
      dataIndex: "status",
      key: "Status",
    },
    // {
    //   title: <p className='p-1 text-center '>Stop Price</p>,
    //   dataIndex: 'Stop_Price',
    //   key: 'Stop_Price',
    // },
  ];

  // useEffect(() => {
  //   if(Api){
  //     orderHistory()
  //   }
  // }, [Api, selectedSymbols])

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSymbolFilter = (symbol) => {
    const updatedSelectedSymbols = [...selectedSymbols];

    if (updatedSelectedSymbols.includes(symbol)) {
      updatedSelectedSymbols.splice(updatedSelectedSymbols.indexOf(symbol), 1);
    } else {
      updatedSelectedSymbols.push(symbol);
    }
    setSelectedSymbols(updatedSelectedSymbols);
  };

  return (
    <div>
      <div>
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={dataSource}
            scroll={{
              x: 1500,
            }}
            
          />
        </Spin>
        <div className="flex items-center gap-1 my-2 ">
        <IoInformationCircleOutline />
        <p className="text-xs">Displays the order history for the past 7 days only.</p>
      </div>
      </div>
    </div>
  );
};

export default TradeHistoryFuture;
